import { render, staticRenderFns } from "./ChangeTermTypeSlidebar.vue?vue&type=template&id=08869cbe"
import script from "./ChangeTermTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangeTermTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports